// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getIltCourseData } from '../../../apis/iltCourse';
import { ILTCourse } from '../../../types/Model';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
import { RootState } from '../../rootReducer';

const { getIltCourseDataActions } = actionCreatorsList;

const outputActions = {
  success: getIltCourseDataActions.success,
  failure: getIltCourseDataActions.failure
};

type RequestActionTypes = ActionType<typeof getIltCourseDataActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

const getIltCourseDataEpic = (
  action$: Observable<RootAction>,
  _state$?: Observable<RootState>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getIltCourseDataActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const id = action.payload.id || 0;
      // send api promise
      return getIltCourseData(id)
        .then((response: AxiosResponse<ILTCourse>) => {
          // handle success case here
          return outputActions.success({
            iltCourseData: response.data
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return outputActions.failure({ error });
        });
    })
  );
};

export { getIltCourseDataEpic as default};
